module.exports = __webpack_public_path__ + "static/media/eye.8f3c4916.png";